// ConstantsWomenCalculator.js
export const SERVER_URL = "https://do-calculate.com/api";

export const Period_EndPoint = "calculate-period";
export const Conception_EndPoint = "calculate-conception";
export const Ovulation_EndPoint = "calculate-ovulation";
export const DueDate_EndPoint = "calculate-due-date";
export const PregnancyConception_EndPoint = "calculate-pregnancy-conception";
export const WeightGainPregnancyCalculate_EndPoint =
  "calculate-pregnancy-weight-gain";
export const PregnancyCalculate_EndPoint = "calculate-pregnancy";
export const womenCalculators = [
  {
    name: "Kalkulator Siklus Menstruasi",
    link: "/calculator/id/period/",
    description:
      "Kalkulator ini membantu melacak siklus menstruasi dan menentukan masa subur.",
    showMain: true,
  },
  {
    name: "Kalkulator Kehamilan",
    link: "/calculator/id/pregnancy/",
    description:
      "Kalkulator ini digunakan untuk menghitung tanggal kehamilan dan memperkirakan minggu kehamilan saat ini.",
    showMain: true,
  },
  {
    name: "Kalkulator Tanggal Pembuahan selama Kehamilan",
    link: "/calculator/id/pregnancy-conception/",
    description: "Kalkulator ini menghitung tanggal pembuahan selama masa kehamilan.",
    showMain: true,
  },
  {
    name: "Kalkulator Tanggal Perkiraan Lahir",
    link: "/calculator/id/pregnancy-due-date/",
    description:
      "Kalkulator ini digunakan untuk memperkirakan tanggal perkiraan lahir berdasarkan tanggal mulai kehamilan.",
    showMain: true,
  },
  {
    name: "Kalkulator Ovulasi",
    link: "/calculator/id/ovulation/",
    description: "Kalkulator ini membantu memperkirakan tanggal ovulasi dan masa subur terbaik.",
    showMain: true,
  },
  {
    name: "Kalkulator Tanggal Pembuahan",
    link: "/calculator/id/conception/",
    description:
      "Kalkulator ini digunakan untuk menghitung tanggal pembuahan berdasarkan tanggal menstruasi dan panjang siklus menstruasi Anda.",
    showMain: true,
  },
  {
    name: "Kalkulator Ukuran Bra",
    link: "/calculator/id/bra_size_calculator/",
    description:
      "Kalkulator ini digunakan untuk menghitung tanggal pembuahan berdasarkan tanggal menstruasi dan panjang siklus menstruasi Anda.",
    showMain: true,
  },
];
export default womenCalculators;